var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[(_vm.is_working)?_c('v-progress-linear',{attrs:{"color":"success","value":_vm.perc}}):_c('v-chip',{attrs:{"small":"","color":_vm.status_color}},[_vm._v(" "+_vm._s(_vm.item.status)+" ")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.status_toop_tip)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }